import { LegacyPortalSearchAvailabilityStatus } from "@spwn-portal/grpc/build";

export const AVAILABILITY_STATUS = [
  {
    id: LegacyPortalSearchAvailabilityStatus.BEFORE_SALE,
    label: "beforeSale",
  },
  {
    id: LegacyPortalSearchAvailabilityStatus.ON_SALE,
    label: "onSale",
  },
  {
    id: LegacyPortalSearchAvailabilityStatus.SALE_ENDED,
    label: "saleEnded",
  },
] as const;
